import {
  AnyObject,
  LocationReviewResponse,
  ReviewResponse,
} from '../../constants/types'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { REVIEW_URL } from '../../constants/urls'
import { PointReviewResponse } from '../../constants/types'
import { MethodsEnum } from '../../constants/enums'

export const reviewsApi = createApi({
  reducerPath: 'reviews/api',
  baseQuery: fetchBaseQuery({
    baseUrl: REVIEW_URL,
  }),
  tagTypes: ['Review'],
  endpoints: (build) => ({
    getPointReview: build.query<PointReviewResponse[], number>({
      query: (pointId: number) => ({
        url: '',
        credentials: 'include',
        params: {
          pointId,
        },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Review' as const, id }))]
          : ['Review'],
    }),
    getLocationReview: build.query<LocationReviewResponse[], number>({
      query: (locationId: number) => ({
        url: '',
        credentials: 'include',
        params: {
          locationId,
        },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Review' as const, id }))]
          : ['Review'],
    }),
    getReview: build.query<ReviewResponse, number | undefined>({
      query: (pointId: number) => ({
        url: '/userReviews',
        credentials: 'include',
        params: {
          pointId,
        },
      }),
      providesTags: (result, error, arg) =>
        result ? [{ type: 'Review', id: result?.id }] : ['Review'],
    }),
    postReview: build.mutation<any, AnyObject>({
      query: (body: AnyObject | null) => ({
        url: '',
        method: MethodsEnum.POST,
        body: body,
        credentials: 'include',
      }),
      invalidatesTags: ['Review'],
    }),
    putReview: build.mutation<any, AnyObject | null>({
      query: (body: AnyObject | null) => ({
        url: '',
        method: MethodsEnum.PUT,
        body: body,
        credentials: 'include',
      }),
      invalidatesTags: (result, error, review) => [
        { type: 'Review', id: review?.id },
      ],
    }),
    deleteReview: build.mutation<void, number>({
      query: (review: number) => ({
        url: '',
        method: MethodsEnum.DELETE,
        credentials: 'include',
        params: {
          id: review,
        },
      }),
      invalidatesTags: (result, error, reviewId) => [
        { type: 'Review', id: reviewId },
      ],
    }),
  }),
})
